<template>
  <div>
    <table
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      style="position: absolute"
      width="100%"
    >
      <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Reporte de Compra de Bienes y Servicio'"
          :titulo="'Reporte de Compra de Bienes y Servicio'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{
              'max-height': this.windowSize.height - 96 + 'px',
              'max-width': '325px',
              width: '325px',
            }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      ver
                    </v-btn>
                    <v-btn
                      color="deep-purple accent-2"
                      dark
                      small
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px"></i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesBienesServicios'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px">Reporte 606</span>
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field
                          v-model="BienesServicios.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                          @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-radio-group v-model="BienesServicios.RadioOpc" column style="margin-top: -6px">
                          <v-radio :value="1" color="teal lighten-2" label="Reporte Por Pantalla"></v-radio>
                          <v-radio :value="2" color="teal lighten-2" label="Generar Archivo para la DGII"></v-radio>
                          <v-radio
                            :value="3"
                            color="teal lighten-2"
                            label="Generar Archivo por Categoria de Gasto"
                          ></v-radio>
                          <v-radio
                            :value="4"
                            color="teal lighten-2"
                            label="Generar Archivo por Categoria de Gasto Resumido"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                          v-model="BienesServicios.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                          @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-combobox
                          v-model="BienesServicios.sucursal"
                          :items="sucursales"
                          dense
                          item-text="descripcion"
                          label="Sucursal:"
                          outlined
                          return-object
                          style="font-size: 13px"
                          @focus="findAllSucursales"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-sitemap" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <v-switch
                          v-if="BienesServicios.RadioOpc === 1 || BienesServicios.RadioOpc === 3"
                          v-model="BienesServicios.orderBySuplidor"
                          class="mt-0"
                          color="teal"
                          label=""
                        >
                          <template v-slot:label>
                            <strong style="color: #000000">
                              Ordenar por suplidor (A-Z): {{ BienesServicios.orderBySuplidor ? "Si" : "No" }}
                            </strong>
                          </template>
                        </v-switch>
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros :Datos="BienesServicios" @DataReporteBasico="DDataReporteBasico" />
              </v-card>
            </v-container>
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{
              'max-height': this.windowSize.height - 96 + 'px',
              'max-width': '325px',
              width: '325px',
            }"
          >
            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      v-model="acti_tb_data"
      label="myAlert"
      max-height="100%"
      max-width="100%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros2"
  import {
    currencyFormatter,
    fechaNueva,
    FormatoFecha,
    getParamFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoBasico,
    RedondeoValor,
    RedondeoValorCantRed,
  } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {
      var json = {
        titulo: "Reporte de Compra de Bienes y Servicios",
        descripcion: "",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
        btnBarraDi: false,
        accion: [
          "ReportesBienesServiciosNew",
          "ReportesBienesServiciosSave",
          "ReportesBienesServiciosRemove",
          "ReportesBienesServiciosAnular",
          "ReportesBienesServiciosPrintList",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },
    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      // EventBus.$on("ReportesBienesServiciosNew", this.new);
      // EventBus.$on("ReportesBienesServiciosSave", this.save);
      // EventBus.$on("ReportesBienesServiciosRemove", this.remove);
      // EventBus.$on("ReportesBienesServiciosAnular", this.remove);
      // EventBus.$on("ReportesBienesServiciosPrintList", this.imprimirList);
      EventBus.$on("emitReportesBienesServicios", this.datostabla)

      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      Rpropietario: [],
      RCaja: [],
      ListaTiposClientes: [],
      windowSize: { width: "auto", height: "auto" },
      BienesServicios: {
        nombre: "REPORTE DE COMPRA DE BIENES Y SERVICIO",
        UrlImprimir: "/reportesmaf/ImprimirListBienesServicio",
        UrlExel: "/reportesmaf/ExcelListBienesServicio",
        UrlCorreo: "/reportesmaf/CorreoListBienesServicio",

        desde: fechaNueva(),
        hasta: fechaNueva(),
        RadioOpc: 1,
        sucursal: undefined,
        orderBySuplidor: false,
      },

      sucursales: [],

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      HoraFormatter2,
      RedondeoValor,
      RedondeoBasico,
      RedondeoValorCantRed,
      fechaNueva,
      getParamFecha,

      findAllSucursales() {
        this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/").then((res) => {
          this.sucursales = res.data
        })
      },

      onResize(e) {
        this.windowSize = e
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      datostabla(e) {
        this.BienesServicios = e
        this.acti_tb_data = false
      },
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},
      DDataReporteBasico() {},
      newwnuevo() {
        EventBus.$emit("actualizaBarraBusqueda2")
      },

      BlurDesde() {
        if (this.BienesServicios.desde.toString().length == 0) {
          this.BienesServicios.desde = this.fechaNueva()
        }
      },

      BlurHasta() {
        if (this.BienesServicios.hasta.toString().length == 0) {
          this.BienesServicios.hasta = this.fechaNueva()
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
        }
      },

      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      async filtro() {},
    },

    watch: {
      "BienesServicios.sucursal"(nuevoValor) {
        if (nuevoValor === "") {
          this.BienesServicios.sucursal = null
        }
      },
      "BienesServicios.RadioOpc"(val) {
        if (val !== 1 && val !== 3) {
          this.BienesServicios.orderBySuplidor = false
        }
      },
    },
  }
</script>

<style></style>
